import { Pipe, PipeTransform } from '@angular/core';
import { Item } from './select.component';

@Pipe({
  name: 'selectedItem',
  standalone: true,
})
export class SelectedItemPipe implements PipeTransform {
  public transform(items: Item[]): string {
    return items?.find((item) => item.selected)?.label ?? null;
  }
}
